import { Components } from '@mui/material';
import { colors } from './colors';

// Override default values from MUI Library
export const components: Components = {
  MuiContainer: {
    styleOverrides: {
      root: {
        maxWidth: '1440px !important',
      },
      maxWidthXl: '1400px !important',
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: '10.5px 12px',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        height: '44px',
        background: '#fff',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        transform: 'translate(0, -26px) scale(1)',
      },
      shrink: {
        transform: 'translate(0, -26px) scale(1)',
      },
    },
  },
  MuiInput: {},
  MuiLink: {
    styleOverrides: {
      root: {
        color: colors.text.primary,
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        // borderRadius: 0,
        boxShadow: 'none',
        fontWeight: 800,
        fontSize: 16,
        padding: '8px 24px',
      },
      sizeSmall: {
        fontSize: 14,
        padding: '12px 26px',
      },
      contained: {
        color: '#FFFFFF',
      },
    },
  },
};
